(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-pb-interest]');
    if (!trigger) return;
    var value = trigger.getAttribute('data-pb-interest');
    var form = document.getElementById('pb-quote-form');
    if (form && value) {
      var checkbox = form.querySelector('input[type="checkbox"][data-pb-option="' + CSS.escape(value) + '"]');
      if (checkbox) checkbox.checked = true;
    }
    var target = document.getElementById('wycena');
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  });

  var form = document.getElementById('pb-quote-form');
  if (form) {
    var messages = {
      valueMissing: 'To pole jest wymagane.',
      typeMismatch: 'Wprowadź poprawny adres e-mail.'
    };
    Array.prototype.forEach.call(form.querySelectorAll('[required]'), function (field) {
      field.addEventListener('invalid', function () {
        if (field.validity.valueMissing) {
          field.setCustomValidity(messages.valueMissing);
        } else if (field.validity.typeMismatch) {
          field.setCustomValidity(messages.typeMismatch);
        } else {
          field.setCustomValidity('');
        }
      });
      field.addEventListener('input', function () {
        field.setCustomValidity('');
      });
    });
  }
})();
